import React from "react";
import PageTemplate from "../components/template/PageTemplate";

const About = () => {
  return (
    <PageTemplate>
      <section className="page-content">
        <h1 className="page-heading">About Me</h1>
        <p>Hi, I'm Christy! I specialize in creative design, branding, and web development.</p>
      </section>
    </PageTemplate>
  );
};

export default About;
